import React from 'react';
import { sanitize } from 'dompurify';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import * as presets from './toolbar-presets';
import { classnames, bem, use } from '../../lib';
export class RichTextEditor extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = (editorState) => {
            this.setState({ editorState }, () => {
                this.props.onChange(this.getHtml());
            });
        };
        this.handleFocus = (e) => {
            this.setState((prev) => (Object.assign(Object.assign({}, prev), { focus: true })));
        };
        this.handleBlur = (e) => {
            this.setState((prev) => (Object.assign(Object.assign({}, prev), { focus: false })));
        };
        this.getContent = (value) => EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(sanitize(value))));
        this.getHtml = () => this.state.editorState.getCurrentContent().hasText()
            ? draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))
            : '';
        this.state = {
            focus: false,
            editorState: this.props.value
                ? this.getContent(this.props.value)
                : EditorState.createEmpty(),
        };
    }
    render() {
        const { focus, editorState } = this.state;
        let toolbar;
        if (this.props.toolbar === 'email')
            toolbar = presets.emailOptions;
        else if (this.props.toolbar === 'saved-details')
            toolbar = presets.savedDetailsOptions;
        else if (this.props.toolbar === 'list')
            toolbar = presets.listOptions;
        else
            toolbar = presets.defaultOptions;
        return (React.createElement(Editor, { placeholder: this.props.placeholder || 'Message (optional)', wrapperClassName: classnames(bem('rich-text-editor__wrapper', use(focus, '--active')), this.props.className), editorClassName: classnames(bem('rich-text-editor__editor', use(focus, '--active'))), toolbarClassName: classnames(bem('rich-text-editor__toolbar', use(focus, '--active'))), toolbarOnFocus: true, stripPastedStyles: true, editorState: editorState, onFocus: this.handleFocus, onBlur: this.handleBlur, onEditorStateChange: (e) => this.handleChange(e), toolbar: toolbar }));
    }
}
export default RichTextEditor;
//# sourceMappingURL=RichTextEditor.js.map